import { useEffect } from 'react';
import { X } from 'lucide-react';

interface IImagePreviewOverlayProps {
  src: string;
  alt?: string;
  onClose: () => void;
  /** Full data-testid for the overlay root; sub-elements compose from it */
  testId?: string;
}

const ImagePreviewOverlay = ({
  src,
  alt = '',
  onClose,
  testId,
}: IImagePreviewOverlayProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={alt || 'Image preview'}
      data-testid={testId}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
        aria-label="Close preview"
        data-testid={testId ? `${testId}CloseButton` : undefined}
      >
        <X className="w-8 h-8" />
      </button>
      <img
        src={src}
        alt={alt}
        className="max-w-[80vw] max-h-[80vh] rounded-lg object-contain shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default ImagePreviewOverlay;
